import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FrameworksComponent } from './authentication/frameworks.component';
import { VisionComponent } from './vision/vision.component';
import { PostauthComponent } from './flashworlds/postauth.component';
import { AvatarmakerComponent } from './flashworlds/avatarmaker.component';
import { StreamComponent } from './flashworlds/stream.component';
import { PhotoStorageComponent } from './flashworlds/photostorage.component';
import { DiscourseComponent } from './flashworlds/discourse.component';
import { DocketsComponent } from './flashworlds/dockets.component';
import { ConfiditialPolicyComponent } from './confiditialpolicy/confiditialpolicy.component';
import { VisitorAgreementsComponent } from './confiditialpolicy/visitoragreements.component';

const routes: Routes = [
  { path: '', component: VisionComponent},
{ path: 'posts', component: FrameworksComponent},
{ path: 'registration', component: FrameworksComponent },
{ path: 'auth/postauth', component: PostauthComponent },
{ path: 'profile/avatarmaker', component: AvatarmakerComponent },
{ path: 'profile/photobook', component: PostauthComponent },
{ path: 'stream/accounts', component: StreamComponent},
{ path: 'profile/photostorage', component: PhotoStorageComponent },
{ path: 'discourse/', component: DiscourseComponent },
// { path: 'profile/shifts', component: ShiftsComponent },
{ path: 'profile/dockets', component: DocketsComponent },
{ path: 'application/confiditialpolicy', component: ConfiditialPolicyComponent },
{ path: 'application/visitoragreements', component: VisitorAgreementsComponent },

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
          exports: [RouterModule]
})

export class AppRoutingModule { }
